export const IMAGE_ASSET_PATH = '/images/quiz-result';
export const VIDEO_ASSET_PATH = '/videos/quiz-result';
